import React from 'react';

const NotFound = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-bggreen">
      <div className="text-center">
        <h1 className="text-5xl font-bold text-red-600">404</h1>
        <p className="text-xl text-gray-800">Oops! Page Not Found.</p>
        <p className="text-xl text-gray-800">Check the url .You may enter Wrong.</p>
        <a href="/" className="mt-4 inline-block bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600">
          Go Back Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
